import { safeFormat } from '@gef-ui/date-fns-utils';
import i18next from 'i18next';
import numeral from 'numeral';
const capitalizeFirstLetter = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const defaultInstance = i18next.createInstance();
defaultInstance.init();
export default {
    interpolation: {
        formatSeparator: ',',
        format: (value, format, lng = 'cs', options)=>{
            // NOTE: retrofit new functionality to legacy mode
            if (Object.keys(defaultInstance.services.formatter?.formats).some((formatter)=>format?.startsWith(formatter))) {
                return defaultInstance.services.formatter?.format(value, format, lng, options);
            }
            if (value instanceof Date) {
                return safeFormat(value, format);
            } else if (value?._isAMomentObject) {
                return value.format(format);
            } else if (typeof value === 'number') {
                // Corresponding to issue of numeral.js - https://github.com/adamwdraper/Numeral-js/issues/135
                return numeral(value).format(format).replace(/,/g, '\u00A0');
            }
            if (value && format) {
                switch(format.toLowerCase()){
                    case 'capital':
                        return capitalizeFirstLetter(value);
                    case 'upper':
                        return value.toUpperCase();
                    case 'lower':
                        return value.toLowerCase();
                    default:
                        return value;
                }
            }
            return value ? value.toString() : value;
        }
    }
};
